export default "__VITE_ASSET__1dd7a10b__"